import React, { useEffect, useState } from 'react'

import { route } from '@bikemap/js/api'
import { Route } from '@bikemap/js/entities'
import { RouteTile } from '@bikemap/components/RouteTile'
import { GridList } from '@bikemap/components/GridList'
import sessionData from '@bikemap/js/services/sessionData'
import { WEB_APP_URLS } from '@bikemap/js/settings'
import { getWebAppParams } from '../global/web-app-links'

/**
 * Encapsulated component that makes a route search query and shows the results
 * in a grid.
 * @param {Object} props
 * @param {number} props.count
 * @param {import("@bikemap/js/api/services/RouteApiService").RouteListParams} props.searchParams
 * @param {boolean} [props.row]
 */
const RouteSuggestions = ({ count, searchParams, row }) => {
    const [routes, setRoutes] = useState({})
    const [users, setUsers] = useState({})
    const [routeIds, setRouteIds] = useState([])
    const [isQuerying, setIsQuerying] = useState(true)

    useEffect(() => {
        route.list({
            pageSize: count,
            ...searchParams,
        }).then(({ results, entities }) => {
            setRoutes(entities.routes)
            setUsers(entities.users)
            setRouteIds(results)
            setIsQuerying(false)
        })
    }, [])

    const handleFavorite = (routeId, status) => {
        const routeUpdate = Route.copy(routes[routeId])
        if (status) {
            routeUpdate.favor()
            route.favor(routeId)
        } else {
            routeUpdate.unfavor()
            route.unfavor(routeId)
        }
        setRoutes({
            ...routes,
            [routeId]: routeUpdate,
        })
    }

    const gridProps = {
        count,
        loading: isQuerying,
        items: routeIds,
        renderItem: item => {
            const route = routes[item]
            const tileProps = {
                route,
                user: users[route.user],
                onFavorite: sessionData.getCurrentLoggedInState()
                    ? status => { handleFavorite(route.id, status) }
                    : null,
                getRouteUrl: () => WEB_APP_URLS.WEB_APP_ROUTE_DETAILS_URL.replace(':id', route.id) + getWebAppParams(),
            }
            return <RouteTile {...tileProps} />
        },
        renderPlaceholder: () => <RouteTile />,
        row,
    }

    return <GridList {...gridProps} />
}

export default RouteSuggestions
